import React from 'react';
import icon from '../../../../../../assets/icons/charts/zoomAndFilter/icon_facet_line.svg';
import SVG from "react-inlinesvg";

const IconFacetLineChart = () => (
    <SVG src={icon}  height={40} style = {{ marginTop: 10}} />
);
export default IconFacetLineChart;